var _defs, _g, _path, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWatchlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a8a8a8;}.cls-2{fill:none;stroke:#a8a8a8;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_management",
    "data-name": "user management"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-1",
    d: "M50,41.91A9.09,9.09,0,1,0,59.09,51,9.09,9.09,0,0,0,50,41.91Zm0,13.64A4.55,4.55,0,1,1,54.55,51h0A4.57,4.57,0,0,1,50,55.55Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.89,78.74c-1.27.09-2.57.14-3.89.14-31,0-46.5-28-46.5-28S19.1,23.12,50,23.12,96.5,50.86,96.5,50.86A60.85,60.85,0,0,1,85.19,64.59"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "user_management-2",
    "data-name": "user management"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348-2",
    "data-name": "Path 348",
    className: "cls-1",
    d: "M50,31A20,20,0,1,0,70,51,20,20,0,0,0,50,31Zm0,34.73A14.73,14.73,0,1,1,64.73,51h0A14.75,14.75,0,0,1,50,65.73Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.37,67.2,85.75,94.58A5.52,5.52,0,0,0,91.34,93c2.76-2.66,1.74-5.23,1.74-5.23L65.4,60.09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlist);
export default __webpack_public_path__ + "static/media/watchlist.b7c7ed5572c9afdc7a5af79db6fd0e86.svg";
export { ForwardRef as ReactComponent };